import styled from 'styled-components';

export const ButtonContainer = styled.div`
    text-align: center;
    margin-top: 16px;

    .gpay-card-info-container {
        width: auto;
        pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
    }
`;
